module.exports = __webpack_public_path__ + "img/connect_wires_direct_install.95681342.png";